import { Injectable } from '@angular/core';

export interface BadgeItem {
    type: string;
    value: string;
}
export interface Saperator {
    name: string;
    type?: string;
}
export interface SubChildren {
    state: string;
    name: string;
    type?: string;
}
export interface ChildrenItems {
    Estado: string;
    Nombre: string;
    type?: string;
    subchild?: SubChildren[];
}

export interface Menu {
    Guid?: string;
    Estado: string;
    Nombre: string;
    type: string;
    Icono: string;
    badge?: BadgeItem[];
    saperator?: Saperator[];
    children?: ChildrenItems[];
}

const MENUITEMS = [
    {
        Estado: 'dashboard',
        Nombre: 'Dashboards',
        type: 'link',
        Icono: 'av_timer',
    },
    {
        Estado: 'catalogs',
        Nombre: 'Catálogos',
        type: 'sub',
        Icono: 'apps',
        children: [
            { Estado: 'clients', Nombre: 'Clientes', type: 'link' },
            { Estado: 'users', Nombre: 'Usuarios', type: 'link' },
            { Estado: 'concepts', Nombre: 'Conceptos de Facturación', type: 'link' },
        ]
    },
    {
        Estado: 'metrology',
        Nombre: 'Metrología',
        type: 'sub',
        Icono: 'straighten',
        children: [
            { Estado: 'instruments', Nombre: 'Instrumentos', type: 'link' },
            { Estado: 'procedures', Nombre: 'Procedimientos', type: 'link' },
            { Estado: 'norms', Nombre: 'Normas', type: 'link' },
            { Estado: 'patterns', Nombre: 'Patrones', type: 'link' },
            { Estado: 'unit', Nombre: 'Unidad', type: 'link' },
            { Estado: 'methods', Nombre: 'Metodos', type: 'link' },
        ]
    },
    {
        Estado: 'billing',
        Nombre: 'Facturación',
        type: 'sub',
        Icono: 'paymant',
        children: [
            { Estado: 'requests', Nombre: 'Facturación', type: 'link' },            
        ]
    },
    {
        Estado: 'certificates',
        Nombre: 'Certificados',
        type: 'link',
        Icono: 'poll',
    },
];

@Injectable()
export class MenuItems {
    getMenuitem(): Menu[] {
        return MENUITEMS;
    }
}
